import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Diamond = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="83" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.2543 0.241318L0.113594 41.382L41.2543 82.5228L82.395 41.382L41.2543 0.241318Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
